/**
 * 无副作用的纯工具函数
 */

export const $ = function (selector, parent) {
  parent = parent || document;
  return parent.querySelector(selector);
};

export const $$ = function (selector, parent) {
  parent = parent || document;
  return Array.prototype.slice.call(parent.querySelectorAll(selector));
};

export function createError(code, message) {
  let _message = message || '未知错误';
  let _code = code || '';

  if (_message.match(/Network Error/i)) {
    _message = '网络未连接';
    _code = 'network';
  }

  let error = new Error(_message);
  error.code = _code;

  return error;
}

export function asyncLoadJs(url) {
  return new Promise((resolve, reject) => {
    let hasLoaded = $$('script[src="' + url + '"]').length > 0;
    if (hasLoaded) {
      resolve();
      return;
    }

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
      window.onloadScript?.(url);
    };
    script.onerror = (error) => {
      reject(error);
    };
  });
}

export function showToast(val) {
  window.wv.isMethodValid('showToast')
    ? window.wv.invoke('BrowserWeb.showToast', val)
    : import(
        /* webpackChunkName: "lib-browser-toast" */ '@oppobrowser/lib-browser-toast'
      ).then((toast) => {
        toast.show(val);
      });
}

export const query = new URLSearchParams(window.location.search);

export const offset = function (elem) {
  var top = 0,
    left = 0,
    width = elem.offsetWidth,
    height = elem.offsetHeight;

  while (elem.offsetParent) {
    top += elem.offsetTop;
    left += elem.offsetLeft;
    elem = elem.offsetParent;
  }

  return {
    top: top,
    left: left,
    width: width,
    height: height,
  };
};

export const getWin = function (attr, val) {
  if (val !== undefined) {
    document.documentElement[attr] = val;
    document.body[attr] = val;
  }
  return document.documentElement[attr] || document.body[attr];
};

export const getCss = function (curEle, attr) {
  var reg = /^(-?\d+(\.\d+)?)(?:px|em|pt|deg|rem)$/;
  var val = window.getComputedStyle(curEle, null)[attr];
  return reg.test(val) ? parseFloat(val) : val;
};

export const serialize = function (obj) {
  return (
    '?' +
    Object.keys(obj)
      .reduce(function (a, k) {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
      }, [])
      .join('&')
  );
};

/**
 * 节流throttle代码(时间戳+定时器)
 * @param {Function} func
 * @param {Number} delay 时间长度 毫秒
 * @param {Boolean} isNeedSetTimeOut 是否要使用SetTimeOut false:则delay时间内只执行一次
 */
export function throttle(func, delay, isNeedSetTimeOut = true) {
  let timer = null;
  let startTime = 0;
  return function () {
    const curTime = Date.now();
    const remaining = delay - (curTime - startTime);
    const context = this;
    const args = arguments;
    timer && clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else if (isNeedSetTimeOut) {
      timer = setTimeout(() => func.apply(context, args), remaining);
    }
  };
}

/**
 *
 * @param {function} func 需要防抖的函数
 * @param {number} delay 毫秒，防抖期限值
 * @returns
 */
export function debounce(func, delay) {
  let timer = 0;
  return function () {
    timer && clearTimeout(timer);
    timer = setTimeout(func.bind(this, ...arguments), delay);
  };
}

export const extend = function (defaultConfig, config) {
  var obj = {};
  for (var attr in defaultConfig) {
    obj[attr] = config[attr] || defaultConfig[attr];
  }
  return obj;
};

// 异步加载外部css
export function asyncLoadStyle(url) {
  return new Promise((resolve, reject) => {
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = () => {
      resolve();
    };

    link.onerror = (err) => {
      reject(err);
    };
    document.head.appendChild(link);
  });
}

// 深拷贝
export function deepClone(obj) {
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === 'object') {
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        //判断ojb子元素是否为对象，如果是，递归复制
        if (obj[key] && typeof obj[key] === 'object') {
          objClone[key] = deepClone(obj[key]);
        } else {
          //如果不是，简单复制
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
}

// 是否已经定义 不能用于检查未申明变量 请单独使用typeof判断
export function isDef(o) {
  return typeof o !== 'undefined';
}

/**
 * 获取查询参数
 * @param name
 * @param url
 * @returns {string|string}
 */
export function getQuery(name, url) {
  const u = url || window.location.search.replace('&amp;', '&');
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = u.substr(u.indexOf('?') + 1).match(reg);
  return r != null ? r[2] : '';
}

// 获取网络状态
// bluetooth: 蓝牙
// cellular: 数据连接，如3g，4g
// wifi： wifi
// ethernet: 以太网
// wimax: 微波
// none: 没有连接网络
// mixed: 多种网络连接
// other: 已知的连接类型，但不是上述任何的连接类型之一
// unknown: 用户代理已建立网络连接，但无法或不愿确定底层连接技术

export function getNetworkType() {
  const network =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;
  // v8.5需求 1: WLAN和移动网络，2: 仅WLAN，3: 不自动播放；默认为1，如果用户设置过则忽略此配置 （请使用定投策略）
  return network.type || network.effectiveType;
}

/**
 * 使用闭包缓存函数的返回值(不要太过频繁使用)
 * @param {*} func
 * @returns
 */
export function cached(func) {
  const cache = Object.create(null);
  return function (...args) {
    const key = JSON.stringify(args);
    if (isDef(cache[key])) {
      return cache[key];
    }
    const result = func.apply(this, args);
    cache[key] = result;
    return result;
  };
}

/**
 * 获取对象中的某个属性的数据 例如:获取 object.a.b 则 getDataByPath(object,'a.b','兜底')
 * @param {Object} obj 数据对象
 * @param {String} path 需要获取的key的路径
 * @param {*} defaultText 默认值,获取不到数据时的默认值
 * @returns
 */
export function getDataByPath(obj, path, defaultText) {
  const hasDefault = typeof defaultText !== 'undefined';
  const segments = path.split('.');
  function getResult() {
    return hasDefault ? (typeof obj !== 'undefined' ? obj : defaultText) : obj;
  }
  if (typeof obj === 'undefined') {
    return getResult();
  }
  for (let i = 0; i < segments.length; i++) {
    if (typeof obj === 'undefined' && typeof hasDefault !== 'undefined') {
      return defaultText;
    }
    obj = obj[segments[i]];
  }
  return getResult();
}

/**
 * 是否为原生代码 (增加缓存)
 * @param {*} fnPath 方法路径 eg: OppoWebPage.getUUKA
 * @returns
 */
export const isNativeCode = cached(function (fnPath) {
  let fn = getDataByPath(window, fnPath);
  if (!fn) return false;
  try {
    fn = fn.toString();
  } catch (error) {
    fn = '';
    console.log('isNativeCode error', fnPath);
  }
  if (!fn) return false;
  return /^function\s+\(\)\s+\{\s+\[native code\]\s+\}$/.test(fn);
});

export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

/**
 * fadeIn 动画 fadeOut 使用 1 - p 则是进度
 * @param {function} func
 * @param {number} time 动画总时差
 * @returns
 */
export function fade(func, time = 200, curProgress) {
  let startTime = null;
  if (curProgress && performance?.now) {
    startTime = performance.now() - time * curProgress;
  }
  function _fadeIn(timestamp) {
    if (!startTime) startTime = timestamp;

    const progress = timestamp - startTime;
    const p = Math.max(0, Math.min(progress / time, 1)); // p 从小到大

    func.call(null, p);
    if (progress < time) {
      requestAnimationFrame(_fadeIn);
    }
  }
  requestAnimationFrame(_fadeIn);

  // 用于结束动效
  function done() {
    startTime = startTime - time;
  }
  return {
    done,
  };
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj) == '[object Object]';
}

// 获取真实结果，如果code不为0，就返回null
export const getResult = function (obj) {
  if (obj && obj.code === 0) {
    return obj.data;
  }
  return null;
};

// 使用JSON.parse 解析数据
export const jsonParse = function (str) {
  if (typeof str !== 'string') {
    return str;
  }
  try {
    const obj = JSON.parse(str);
    return obj;
  } catch (e) {
    return str;
  }
};

export function getAndroidVersion() {
  let version = null;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('android') > 0) {
    const reg = /android [\d._]+/gi;
    const v_info = ua.match(reg);
    version = (v_info + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); //得到版本号4.2.2
    version = parseInt(version.split('.')[0]); // 得到版本号第一位
  }
  return version;
}
